import { createApp } from 'vue'
import App from './App.vue'

import './assets/styles/main.css'
import { getContainerConfig, type AppConfig } from './containers-matching'
import { DelphiPluginLoader } from '@/vue/plugin-common-plugins'

/** Create Vue app from the requested container with needed plugins */
const initApp = async (config: AppConfig) => {
  const app = createApp(
    App,
    // avoid eslint error (??)
    // eslint-disable-next-line vue/require-name-property
    { mainComponent: config.component },
  )

  const VueCommonPlugins = await DelphiPluginLoader()
  app.use(VueCommonPlugins)

  app.mount(container)
}

const container = document.querySelector('#db-app') as HTMLElement
const containerType = container.getAttribute('data-container')

const config = getContainerConfig(containerType)

if (containerType === 'rfp-form') {
  import('./AppRfp/create-app').then(({ createAppRfp }) => {
    createAppRfp(container)
  })
} else if (containerType === 'booking-confirmation') {
  import('./AppBookingConfirmation/create-app').then(({ createAppBookingConfirmation }) => {
    createAppBookingConfirmation(container)
  })
} else if (containerType === 'booking-funnel') {
  import('./AppBookingFunnel/create-app').then(({ createAppBookingFunnel }) => {
    createAppBookingFunnel(container)
  })
} else if (containerType === 'hotel-search') {
  import('./AppHotelSearch/create-app').then(({ createAppHotelSearch }) => {
    createAppHotelSearch(container)
  })
} else {
  if (!config) {
    throw new Error(`DB APP - missing configuration for key ${containerType}`)
  }

  initApp(config)
}
